/* =====================================================================================
   SPRACH-MEDIEN-GUARD (ollihess, custom)

   ollihess.de laeuft komplett hinter dem Weglot-Proxy: /en/-Seiten sind nachtraeglich
   uebersetztes DE-HTML, Shopify rendert immer mit request.locale=de. Die Sprache ist
   deshalb NUR im Browser erkennbar, ueber das von Weglot pro Sprache umgeschriebene
   <html lang>. Galerie-Medien mit Sprach-Marker im ALT ("@de"/"@en") tragen serverseitig
   data-oh-lang="<code>" (snippets/oh-media-lang-attr.liquid); dieses Skript blendet sie
   passend zur Seitensprache ein oder aus (hidden + data-oh-lang-hide fuer die CSS-Regel
   in oh.css und fuer Impacts Zoom, der seine Bildliste ueber :not([hidden]) aufbaut).
   Serverseitig sind Nicht-de-Medien als No-JS-Fallback bereits versteckt.
   Impacts Varianten-Filter setzt beim variant:change item.hidden fuer alle Items neu,
   darum wird die Sprachwahl danach erneut angewendet.
   ===================================================================================== */
(function () {
  var pageLang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();

  function apply(root) {
    root.querySelectorAll('[data-oh-lang]').forEach(function (el) {
      var match = el.getAttribute('data-oh-lang') === pageLang;
      el.hidden = !match;
      if (match) {
        el.removeAttribute('data-oh-lang-hide');
      } else {
        el.setAttribute('data-oh-lang-hide', '');
      }
    });
  }

  function init() {
    document.querySelectorAll('product-gallery').forEach(function (gallery) {
      if (!gallery.querySelector('[data-oh-lang]')) return;
      apply(gallery);
      var form = document.forms[gallery.getAttribute('form')];
      if (!form) return;
      form.addEventListener('variant:change', function () {
        requestAnimationFrame(function () {
          apply(gallery);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
